import { OrderStatus } from 'models/Order'
import { GenericObject } from 'types/GenericObject'

export const orderStatusMap: GenericObject<number> = Object.values(OrderStatus).reduce(
  (acc, curr, index) => {
    return { ...acc, [curr]: index }
  },
  {}
)
